import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import BasicLayout from "../../layauots/BasicLayout";
import { Card, Alert, AlertTitle, Checkbox, Autocomplete, TextField } from "@mui/material";
import EstadosSiNo from "../../Utils/estadossino";
import TipoPersona from "../../Utils/TipoPersona";
import MDBox from "../../controls/MDBox";
import MDTypography from "../../controls/MDTypography";
import MDInput from "../../controls/MDInput";
import MDButton from "../../controls/MDButton";
import { Save } from "react-bootstrap-icons";
import { ExitToApp } from "@mui/icons-material";
import bgImage from "../../../assets/images/bg-sign-up-cover.jpeg";
import { getData, pathData } from "../../Utils/Http/api";
import { fetchSujetoIdentificacion } from "../../Utils/SujetoIdentificacion";
const SujetoEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        idSujeto: id,
        nombre: "",
        tipoIdentificacion: "",
        identificacion: "",
        idSujetoTipoIdentificacion: "",
        concursado: null,
        fallecido: null,
        quebrado: null,
        tipoPersona: null,
    });

    const [elementsTipoIdentificacion, setElementsTipoIdentificacion] = useState([]);
    const [selectedTipoIdentificacion, setSelectedTipoIdentificacion] = useState(null);
    const [selectedConcursado, setSelectedConcursado] = useState(null);
    const [selectedFallecido, setSelectedFallecido] = useState(null);
    const [selectedQuebrado, setSelectedQuebrado] = useState(null);
    const [selectedTipoPersona, setSelectedTipoPersona] = useState(null);
    const [mensaje, setMensaje] = useState("");
    const [exito, setExito] = useState(false);
    const [grabando, setGrabando] = useState(false);
    const [nombreboton, setnombreboton] = useState("Cancelar");

    useEffect(() => {
        // load tipos de identificacion
        (async () => {
            try {
                const tipos = await fetchSujetoIdentificacion();
                setElementsTipoIdentificacion(tipos || []);
            } catch (ex) {
                console.error('Error cargando tipos de identificacion', ex);
            }
        })();

        const fetchData = async () => {
            try {
                const res = await getData(`/SujetoGet/${id}`);

                if (res) {
                    setFormData({
                        idSujeto: res.value.idSujeto,
                        nombre: res.value.nombre,
                        tipoIdentificacion: res.value.tipoIdentificacion,
                        identificacion: res.value.identificacion,
                        idSujetoTipoIdentificacion: res.value.idSujetoTipoIdentificacion ?? "",
                        concursado: !!res.value.concursado,
                        fallecido: !!res.value.fallecido,
                        quebrado: !!res.value.quebrado,
                        tipoPersona: res.value.tipoPersona || null,
                    });
                    // set selected tipo if tipos already loaded
                    // we'll attempt to match after tipos are set in a separate effect
                }
            } catch (ex) {
                console.error("Error cargando datos:", ex);
            }
        };
        fetchData();
    }, [id]);

    // when tipos or formData.tipoIdentificacion change, set selectedTipoIdentificacion
    useEffect(() => {
        if (!elementsTipoIdentificacion || elementsTipoIdentificacion.length === 0) return;
        if (formData.tipoIdentificacion) {
            const found = elementsTipoIdentificacion.find(x => x.idSujetoIdentificacion === formData.tipoIdentificacion || x.idSujetoIdentificacion === formData.tipoIdentificacion || x.idTipoIdentificacion === formData.tipoIdentificacion || x.descripcion === formData.tipoIdentificacion);
            setSelectedTipoIdentificacion(found || elementsTipoIdentificacion[0]);
        } else {
            setSelectedTipoIdentificacion(elementsTipoIdentificacion[0]);
        }
    }, [elementsTipoIdentificacion, formData.tipoIdentificacion]);

    // set selects for otros campos cuando cambian en formData
    useEffect(() => {
        if (formData.concursado !== null && formData.concursado !== undefined) {
            const opt = formData.concursado ? EstadosSiNo.SI : EstadosSiNo.NO;
            setSelectedConcursado(opt);
        } else {
            setSelectedConcursado(null);
        }
        if (formData.fallecido !== null && formData.fallecido !== undefined) {
            const opt = formData.fallecido ? EstadosSiNo.SI : EstadosSiNo.NO;
            setSelectedFallecido(opt);
        } else {
            setSelectedFallecido(null);
        }
        if (formData.quebrado !== null && formData.quebrado !== undefined) {
            const opt = formData.quebrado ? EstadosSiNo.SI : EstadosSiNo.NO;
            setSelectedQuebrado(opt);
        } else {
            setSelectedQuebrado(null);
        }
        if (formData.tipoPersona !== null && formData.tipoPersona !== undefined) {
            let opt = null;
            if (formData.tipoPersona === 'PF' || formData.tipoPersona === 1) opt = TipoPersona.PF;
            else if (formData.tipoPersona === 'PJ' || formData.tipoPersona === 2) opt = TipoPersona.PJ;
            setSelectedTipoPersona(opt);
        } else {
            setSelectedTipoPersona(null);
        }
    }, [formData.concursado, formData.fallecido, formData.quebrado, formData.tipoPersona]);
    const handleVolver = () => {
        navigate("/SujetoList");
    };

    const handleAutocompleteTipoIdentificacionChange = (event, value) => {
        setSelectedTipoIdentificacion(value);
        // keep formData in sync with selected tipo id/value
        setFormData(prev => ({ ...prev, tipoIdentificacion: value?.descripcion || '', idSujetoTipoIdentificacion: value?.idSujetoIdentificacion ?? null }));
    };
    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = async () => {
        try {
            if (!formData.nombre.trim()) {
                setMensaje("El campo Nombre es obligatorio");
                setExito(false);
                return;
            }

            setGrabando(true);
            setnombreboton("Volver");
            setMensaje("");

            // build payload explicitly so we send the selected tipo identificacion id
            const payload = {
                idSujeto: formData.idSujeto,
                nombre: formData.nombre,
                identificacion: formData.identificacion,
                idSujetoTipoIdentificacion: selectedTipoIdentificacion?.idSujetoIdentificacion ?? formData.idSujetoTipoIdentificacion ?? null,
                concursado: (selectedConcursado?.valor ?? false) ? 1 : 0,
                fallecido: (selectedFallecido?.valor ?? false) ? 1 : 0,
                quebrado: (selectedQuebrado?.valor ?? false) ? 1 : 0,
                tipoPersona: (selectedTipoPersona?.valor === 'PF') ? 1 : (selectedTipoPersona?.valor === 'PJ') ? 2 : null,
            };

            const res = await pathData("/SujetoUpdate", payload);

            if (res?.isSuccess) {
                setMensaje("¡Sujeto actualizado exitosamente!");
                setExito(true);
            } else {
                setMensaje(res?.error || "Error al actualizar");
                setExito(false);
                setGrabando(false);
            }
        } catch (error) {
            setMensaje("Error en la solicitud");
            setExito(false);
            setGrabando(false);
        }
    };

    return (
        <BasicLayout image={bgImage}>
            <Card style={{ width: "157%" }}>
                <MDBox
                    variant="gradient"
                    bgColor="secondary"
                    borderRadius="lg"
                    coloredShadow="light"
                    mx={2}
                    mt={-3}
                    p={3}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Editar Sujeto
                    </MDTypography>
                    <MDTypography display="block" variant="button" color="white" my={1}>
                        Modifica los datos del sujeto seleccionado.
                    </MDTypography>
                </MDBox>

                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form">
                        <MDBox mb={2}>
                            <MDInput
                                type="text"
                                name="nombre"
                                label="Nombre"
                                variant="standard"
                                value={formData.nombre}
                                onChange={handleInputChange}
                                fullWidth
                            />
                        </MDBox>
                        <MDBox mb={2}>
                            <Autocomplete
                                onChange={handleAutocompleteTipoIdentificacionChange}
                                options={elementsTipoIdentificacion}
                                getOptionLabel={(option) => option.descripcion || 'Seleccione Tipo Identificacion'}
                                value={selectedTipoIdentificacion || null}
                                getOptionSelected={(option, value) =>
                                    option.idTipoIdentificacion === value.idSujetoIdentificacion
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Seleccione Tipo Identificacion"
                                        variant="outlined"
                                    />

                                )}
                                style={{ flex: 1 }}
                                defaultValue={selectedTipoIdentificacion || []}
                                isOptionEqualToValue={(option, value) =>
                                    option.descripcion === value.descripcion
                                }
                            />

                        </MDBox>
                        <MDBox mb={2}>
                            <MDInput
                                type="text"
                                name="identificacion"
                                label="Identificación"
                                variant="standard"
                                value={formData.identificacion}
                                onChange={handleInputChange}
                                fullWidth
                            />
                        </MDBox>

                        <MDBox mb={2} display="flex" gap={2} flexWrap="wrap">
                            <Autocomplete
                                options={Object.values(EstadosSiNo)}
                                getOptionLabel={(o) => o.descripcion}
                                value={selectedConcursado}
                                onChange={(e, v) => setSelectedConcursado(v)}
                                renderInput={(params) => <TextField {...params} label="Concursado" />}
                                sx={{ minWidth: 220 }}
                            />
                            <Autocomplete
                                options={Object.values(EstadosSiNo)}
                                getOptionLabel={(o) => o.descripcion}
                                value={selectedFallecido}
                                onChange={(e, v) => setSelectedFallecido(v)}
                                renderInput={(params) => <TextField {...params} label="Fallecido" />}
                                sx={{ minWidth: 220 }}
                            />
                            <Autocomplete
                                options={Object.values(EstadosSiNo)}
                                getOptionLabel={(o) => o.descripcion}
                                value={selectedQuebrado}
                                onChange={(e, v) => setSelectedQuebrado(v)}
                                renderInput={(params) => <TextField {...params} label="Quebrado" />}
                                sx={{ minWidth: 220 }}
                            />
                            <Autocomplete
                                options={Object.values(TipoPersona)}
                                getOptionLabel={(o) => o.descripcion}
                                value={selectedTipoPersona}
                                onChange={(e, v) => setSelectedTipoPersona(v)}
                                renderInput={(params) => <TextField {...params} label="Tipo Persona" />}
                                sx={{ minWidth: 220 }}
                            />
                        </MDBox>

                        <MDBox mb={1} style={{ display: "flex", gap: "16px" }}>
                            <MDButton
                                onClick={handleSubmit}
                                variant="gradient"
                                color="success"
                                endIcon={<Save />}
                                disabled={grabando}
                                fullWidth
                            >
                                Grabar
                            </MDButton>

                            <MDButton
                                onClick={handleVolver}
                                variant="gradient"
                                color="error"
                                endIcon={<ExitToApp />}
                                fullWidth
                            >
                                {nombreboton}
                            </MDButton>
                        </MDBox>
                    </MDBox>

                    {mensaje && (
                        <Alert severity={exito ? "success" : "error"}>
                            <AlertTitle>{exito ? "Felicitaciones" : "Error"}</AlertTitle>
                            {mensaje}
                        </Alert>
                    )}
                </MDBox>
            </Card>
        </BasicLayout>
    );
};

export default SujetoEdit;
